<template>
  <div
    ref="dialog"
    class="mdc-dialog"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="my-dialog-title"
    aria-describedby="my-dialog-content"
  >
    <div class="mdc-dialog__container">
      <div class="mdc-dialog__surface">
        <h2 class="mdc-dialog__title" id="my-dialog-title">User settings</h2>
        <div class="mdc-dialog__content" id="my-dialog-content">
          <h4>Delete account</h4>
          <p>Type your email and press the button to permanently delete your account and personal data</p>
          <Input v-model="email" label="Email"></Input>
          <div></div>
          <button @click="onClickOnDeleteAccount()" :class="{'mdc-button mdc-button--raised mdc-button--error': true, 'mdc-button--disabled': !canDeleteAccount}">
            <span class="mdc-button__label">Delete account</span>
          </button>
        </div>
        <footer class="mdc-dialog__actions">
          <button
            type="button"
            class="mdc-button mdc-dialog__button"
            data-mdc-dialog-action="close"
          >
            <span class="mdc-button__label">Cancel</span>
          </button>
        </footer>
      </div>
    </div>
    <div class="mdc-dialog__scrim"></div>
  </div>
</template>

<script>
import { MDCDialog } from "@material/dialog";
import Input from "./Input.vue";
import {AuthService} from '../services/AuthService.js';

export default {
  props: ["visible", "user"],
  mounted() {
    this.dialog = new MDCDialog(this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", () => {
      this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data() {
    return {
      errored: false,
      email: "",
    };
  },
  methods: {
    onClickOnDeleteAccount() {
      if(this.canDeleteAccount) {
        AuthService.deleteAccount(this.$firebase);
        this.$emit('onAccountDeleted');
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.errored = false;
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  computed: {
    canDeleteAccount() {
      return this.user && this.user.email === this.email;
    }
  },
  components: {
    Input
  }
};
</script>

<style lang="scss" scoped>
.mdc-dialog__surface {
  min-width: 320px;
  max-width: 320px;
}
.separator {
  height: 10px;
}
.mdc-button--error {
  margin-top: 20px;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/UserSettingsDialog.vue